import SignatureSuccessContainer from './SignatureSuccessContainer';

export default SignatureSuccessContainer;
